import {
  Heading_4 as Heading4,
  Loader,
  WarningAlert,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * What the recipient sees while the provider creates their card. A refusal
 * is declined with the mapped copy for a known error and the generic
 * declined copy for any other.
 */
export const CreationState = (props) => {
  const { creationFailure, isStatusPollExhausted, knownProviderErrors } = props;

  if (creationFailure) {
    const { message } = creationFailure;
    const knownError = message ? knownProviderErrors[message] : null;

    return (
      <WarningAlert
        title="Card request declined"
        message={
          knownError?.displayMessage ??
          dictionary.prepaidCards.creation.declinedMessage
        }
      />
    );
  }

  if (isStatusPollExhausted) {
    return (
      <Heading4>{dictionary.prepaidCards.creation.delayedMessage}</Heading4>
    );
  }

  return (
    <>
      <Loader />
      <Heading4>{dictionary.prepaidCards.creation.loadingMessage}</Heading4>
    </>
  );
};

CreationState.propTypes = {
  creationFailure: PropTypes.object,
  isStatusPollExhausted: PropTypes.bool,
  knownProviderErrors: PropTypes.object.isRequired,
};
